import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import View from '../View';
import styled, { createGlobalStyle } from 'styled-components';
import { propsColumn } from './rules';

const GlobalStyle = createGlobalStyle`
  tbody {
    tr.updated-row { 
      &.ant-table-row {
        > td {
          background-color: #F3FFF2 !important;
        }      
      }
      &.ant-table-row:hover {
        > td {
          background-color: #e8ffe6 !important; /* darken 5% */
        }      
      }  
    }
    
    tr.disabled-row {
      &.ant-table-row {
        > td {
          background-color: #fafafa !important;
          color: gray !important;
        }
      }

      &.ant-table-row:hover {
        > td {
          background-color: #f2f2f2 !important; /* darken 3% */
          color: gray !important;
        }
      }
    }
  } 
`;

const TableComponent = ({ hidePagination, pagination, status, rowClassName, columns, ...otherProps }) => (
  <>
    <GlobalStyle />
    <Table
      pagination={
        // prettier-ignore
        !hidePagination ? {
          showSizeChanger: true,
          showQuickJumper: true,
          hideOnSinglePage: true,
          defaultPageSize: 50,
          pageSizeOptions: ['25', '50', '100'],
          ...pagination,
        }
          : false
      }
      rowClassName={(record) => {
        let className = [];
        if (status && record[status] !== undefined && !record[status]) {
          className.push('disabled-row');
        }
        if (rowClassName) {
          className.push(rowClassName(record));
        }

        return className.join(' ');
      }}
      columns={columns.map(propsColumn)}
      {...otherProps}
    />
  </>
);

TableComponent.propTypes = {
  ...Table.propTypes,
  hidePagination: PropTypes.bool,
  status: PropTypes.string,
};

TableComponent.defaultProps = {
  hidePagination: false,
  status: 'status',
  size: 'middle',
  tableLayout: 'auto',
};

const TableColumnOpcoes = styled(View)`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex-wrap: wrap;
  font-size: 16px;
`;

export { TableComponent, TableColumnOpcoes };
